import register  from '../register.js';
import $         from 'jquery';

export default register( 'check-availability', () => {

  // keycodes
  const UP   = 38;
  const DOWN = 40;
  const ESC  = 27;

  const redirectURL = window.redirectOverride || '/signup';

  // exported module
  const check = {

    // places-api base url
    placesbase: 'https://places.cloud.starry.com/autocomplete',
    // try to use geoip from server if it exists, otherwise focus on Boston
    lat: ( window.geoip || {} ).latitude || 42.3601,
    // try to use geoip from server if it exists, otherwise focus on Boston
    lon: ( window.geoip || {} ).longitude || -71.0589,
    // index of the active autocomplete list result
    active: -1,
    // loading spinner timeout
    loadingTimeout: null,

    // initialize
    init() {
      this.getElements();
      this.bindEvents();
    },

    // find some elements
    getElements() {
      this.wrap  = document.querySelector('.autocomplete .input-wrap');
      this.input = document.querySelector('#check-availability-input');
      this.list  = document.querySelector('.autocomplete .results');
    },

    // bind event handlers
    bindEvents() {
      const $input = $( this.input );
      const $list  = $( this.list );

      // listen to input events
      $input.on( 'input', this.debounce( this.onInput.bind( this ) ) );
      // listen to keyup events
      $input.on( 'keyup', this.onKeyUp.bind( this ) );
      // listen to keydown events
      $input.on( 'keydown', this.onKeyDown.bind( this ) );
      // listen to blur events
      $input.on( 'blur', this.onBlur.bind( this ) );
      // listen to li clicks
      $list.on( 'click', 'li', this.select.bind( this ) );
      // listen to li hover
      $list.on( 'mouseover', 'li', this.onMouseOver.bind( this ) );
    },

    // search places-api
    search( str ) {
      let url = `${ this.placesbase }?search=${ str }`;

      url += `&lat= ${ this.lat }`;
      url += `&lon= ${ this.lon }`;

      return $.get( url );
    },

    // generic debounce
    debounce( fn, ms = 200 ) {
      let timer = null;
      return function( ...args ) {
        clearTimeout( timer );
        timer = setTimeout( fn, ms, ...args );
      };
    },

    // respond to input events
    onInput() {
      if ( this.input.value.length < 2 ) {
        this.list.style.display = 'none';
        return;
      }

      // sry, no
      if ( navigator.webdriver ) {
        return;
      }

      const query = this.input.value;

      this.loadingTimeout = setTimeout( () => {
        this.wrap.classList.add('loading');
      }, 200 );

      this.search( query )
      .then( results => {
        this.wrap.classList.remove('loading');

        clearTimeout( this.loadingTimeout );

        const frag = document.createDocumentFragment();

        results = results.slice( 0, 3 );

        const els = results.map( result => {
          const li = document.createElement('li');

          li.setAttribute( 'data-place', JSON.stringify( result ) );

          const html = `
            <strong>${ result.suggestion.name }</strong>
            ${ result.suggestion.locality }, ${ result.suggestion.state }
            ${ result.suggestion.postal_code }
          `;

          li.innerHTML = html;

          if ( result._id ) {
            li.className = 'starry';
          }

          return li;
        });

        const notfound = document.createElement('li');

        notfound.innerHTML = 'Don\'t see yours? <span class="underline">' +
                             'Add your address to the list.</span>';

        els.push( notfound );

        els.forEach( el => frag.appendChild( el ) );

        this.list.innerHTML = '';
        this.list.appendChild( frag );

        this.list.style.display = 'block';

        this.active = -1;
      });
    },

    // respond to keyup events
    onKeyUp( e ) {
      if ( e.keyCode === ESC ) {
        this.input.value = '';
        this.input.blur();
        this.list.style.display = 'none';
      }
    },

    // respond to keydown events
    onKeyDown( e ) {
      const code = e.keyCode;
      const curr = this.list.children[ this.active ];

      if ( this.list.children.length && code === DOWN || code === UP ) {
        const inc    = code === DOWN ? 1 : -1;
        const target = this.list.children[ this.active + inc ];

        if ( target ) {
          if ( curr ) {
            this.list.children[ this.active ].classList.remove('focus');
          }
          this.active = this.active + inc;
          target.classList.add('focus');
        }
        e.preventDefault();
      } else if ( code === 13 ) {
        e.preventDefault();
        if ( curr ) {
          $( curr ).trigger('click');
        } else {
          const target = this.list.children[ this.active = 0 ];
          target.classList.add('focus');
        }
      }
    },

    // respond to input blur events
    onBlur() {
      setTimeout( () => this.list.style.display = 'none', 250 );
    },

    // respond to list item mouseover
    onMouseOver( e ) {
      const curr     = this.list.querySelector('.focus');
      const children = Array.prototype.slice.call( this.list.children );
      const index    = children.indexOf( e.currentTarget );

      if ( curr ) {
        curr.classList.remove('focus');
      }

      this.active = index;
      e.currentTarget.classList.add('focus');
    },

    // focus on an element
    select( e ) {
      const el       = e.currentTarget;
      const tracking = { search: this.input.value || null };

      let href = window.location.origin;

      const props = [
        'place_id',
        'lat',
        'lng',
        'state',
        'city',
        'neighborhood',
        'borough',
        'postal_code',
        'street_number',
        'street',
        'country'
      ];

      props.forEach( prop => tracking[ prop ] = null );

      const currentQuery = new URLSearchParams( window.location.search );
      const redirectQuery = new URLSearchParams();

      if ( el.getAttribute('data-place') ) {

        const place     = JSON.parse( el.dataset.place );
        const installer = currentQuery.get('installer') === 'true';

        this.input.value = '';
        this.list.innerHTML = '';
        this.list.style.display = 'none';

        if ( window.acumen ) {
          const name  = place.name;
          const city  = place.city;
          const state = place.state;
          const zip   = place.postal_code;

          let address = null;

          if ( name && city && state && zip ) {
            address = `${ name }, ${ city }, ${ state }, ${ zip }`;
          }

          props.forEach( prop => tracking[ prop ] = ( place[ prop ] || null ) );
          tracking.place_id = place._id || null;

          window.acumen.track( 'web-submit-check_availability', {
            place_id: place._id || null,
            address
          });
        }

        // Add the trial code to the redirect query if available
        const trial_code = currentQuery.get('trial_code');
        if ( trial_code ) {
          redirectQuery.append( 'trial_code', trial_code );
        }

        if ( place._id ) {
          href += redirectURL + '/' + place._id;

          if ( installer ) {
            redirectQuery.append( 'bypass', true );
            redirectQuery.append( 'sameday', true );
          }
        } else {
          const copy = Object.assign( {}, place );

          delete copy.suggestion;

          const json    = JSON.stringify( copy );
          const escaped = escape( json );
          const base64  = window.btoa( escaped );
          const enc     = window.encodeURIComponent( base64 );

          // this can be docoded via:
          //
          // const str       = location.pathname.split('/').pop();
          // const decoded   = window.atob( decodeURIComponent( str ) );
          // const unescaped = window.unescape( decoded );
          // const place     = JSON.parse( unescaped );

          href += '/register/' + enc;
        }

      // No address found
      } else {
        href += '/register';

        if ( window.acumen ) {
          window.acumen.track( 'web-submit-check_availability', {
            place_id: null,
            address: null
          });
        }
      }

      // Add redirect query only if there are values available
      if ( redirectQuery.toString() !== '' ) {
        href += '?' + redirectQuery.toString();
      }

      // add a loading indicator, then fire off a tracking request
      this.wrap.classList.add('loading');

      $.ajax({
        url: '/availability-checks',
        type: 'POST',
        data: JSON.stringify( tracking ),
        headers: { 'Content-Type': 'application/json' }
      })
      .always( () => {
        this.wrap.classList.remove('loading');

        // not an iframe? just navigate
        if ( window === parent ) {
          location.href = href;
          return;
        }

        // otherwise, let the parent frame know what's up
        parent.postMessage( { event: 'autocomplete', href }, '*' );
      });
    }

  };

  check.init();

  return check;

});
